module.exports = __webpack_public_path__ + "static/media/logo-colypro-main.2953faf6.png";